import styled from "styled-components";
import { Layout } from "antd";
import { media } from "@common/constants";

export const LayoutMaster = styled(Layout)`
  height: 100vh;
`;

export const LayoutMain = styled(Layout)``;
